/**
 *
 * @param {Array} extraProfileData extra_profile_data from a participant object
 * @param {object} options Extra options
 * @param {object} options.filter   Optional; only process entries that match this filter
 * @returns {object}
 */
export function extraProfileData2Object(extraProfileData, { filter } = {}) {
    const output = {};

    for (let i = 0; i < extraProfileData?.length; i++) {
        if (filter && !filter(extraProfileData[i])) continue;

        output[extraProfileData[i].name] = extraProfileData[i].value ?? extraProfileData[i].options;
    }

    return output;
}
